<template>
  <div id="skills-section">
    <div id="stars"></div>
    <div id="stars2"></div>
    <div id="stars3"></div>
    <div class="section-header">
      <h2>What I Do</h2>
    </div>
    <div class="skills-content">
      <div class="skills-container">
        <div class="card">
          <div class="face face1">
            <div class="content">
              <img
                src="../assets/images/experience/responsive-web-devices.jpg"
              />
              <h3>Web Development</h3>
            </div>
          </div>
          <div class="face face2">
            <div class="content">
              <ul class="skills-list">
                <li>Web/UI Design</li>
                <li>Code Responsive Websites & Mobile Applications</li>
                <li>CSS/Sass Styling</li>
                <li>Server Configuration</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="face face1">
            <div class="content">
              <img
                class="vid-prod-img"
                src="../assets/images/experience/cameras.png"
              />
              <h3>Video Production</h3>
            </div>
          </div>
          <div class="face face2">
            <div class="content">
              <ul class="skills-list">
                <li>Concept Creation & Development</li>
                <li>Professional Film Lighting</li>
                <li>Pre/Production Management</li>
                <li>Video Editing</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="face face1">
            <div class="content">
              <img src="../assets/images/experience/digMediaTreeMcF.png" />
              <h3>Digital Marketing</h3>
            </div>
          </div>
          <div class="face face2">
            <div class="content">
              <ul class="skills-list">
                <li>Search Engine Optimization (SEO)</li>
                <li>Digital Strategy</li>
                <li>Custom Content</li>
                <li>Google Analytics</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="face face1">
            <div class="content">
              <img src="../assets/images/experience/Software-Eng.jpg" />
              <h3>Software Engineering</h3>
            </div>
          </div>
          <div class="face face2">
            <div class="content">
              <ul class="skills-list">
                <li>Front End (Vue.js/React)</li>
                <li>Back End (Node.js/MySQL)</li>
                <li>Object Oriented Programming (Javascript)</li>
                <li>Functional Programming</li>
                <li>Amazon Web Services</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="face face1">
            <div class="content">
              <img src="../assets/images/experience/graphic-design.jpg" />
              <h3>Graphic Design</h3>
            </div>
          </div>
          <div class="face face2">
            <div class="content">
              <ul class="skills-list">
                <li>Logo & Branding</li>
                <li>Template Design</li>
                <li>Custom Graphics</li>
                <li>Photo Touch Up & Enhancing</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="face face1">
            <div class="content">
              <img src="../assets/images/experience/problem-solving.jpg" />
              <h3>Special Projects</h3>
            </div>
          </div>
          <div class="face face2">
            <div class="content">
              <ul class="skills-list">
                <li>Consulting</li>
                <li>Tech Help</li>
                <li>Hardware Construction</li>
                <li>You name it, <br />I'll make it happen</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "../scss/stars-background.scss";
@import "../scss/styles.scss";

#skills-section {
  background: radial-gradient(ellipse at bottom, #1b2735 0%, #090a0f 100%);
  overflow: hidden;
  padding-bottom: 4rem;

  .section-header {
    padding: 6rem 1rem 2rem;
    h2 {
      font-size: 3rem;
    }
  }

  .skills-content {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .skills-container {
      width: 1000px;
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      @include sm {
        justify-content: space-around;
      }
      @include lg {
        justify-content: space-between;
      }
    }

    .skills-container .card {
      position: relative;
      cursor: pointer;
    }

    .skills-container .card .face {
      width: 300px;
      height: 200px;
      transition: 0.5s;
    }

    .skills-container .card .face.face1 {
      position: relative;
      background: #333;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
      transform: translateY(100px);
    }

    .skills-container .card:hover .face.face1 {
      background: $mcf-blue;
      transform: translateY(0);
    }

    .skills-container .card .face.face1 .content {
      // opacity: 0.2;
      transition: 0.5s;
      text-align: center;
    }

    .skills-container .card:hover .face.face1 .content {
      opacity: 1;
    }

    .skills-container .card .face.face1 .content img {
      max-width: 92%;
      background: $white;
    }

    .skills-container .card .face.face1 .content h3 {
      margin: 0 0 1rem;
      padding: 0;
      color: #fff;
      text-align: center;
      font-size: 1.5em;
    }

    .skills-container .card .face.face2 {
      position: relative;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;
      box-sizing: border-box;
      box-shadow: 0 20px 50px rgba(0, 0, 0, 0.8);
      transform: translateY(-100px);
    }

    .skills-container .card:hover .face.face2 {
      transform: translateY(0);
    }

    .skills-container .card .face.face2 .content p {
      margin: 0;
      padding: 0;
    }

    .skills-container .card .face.face2 .content a {
      margin: 15px 0 0;
      display: inline-block;
      text-decoration: none;
      font-weight: 900;
      color: #333;
      padding: 5px;
      border: 1px solid #333;
    }

    .skills-container .card .face.face2 .content a:hover {
      background: #333;
      color: #fff;
    }
  }
  .skills-list {
    li {
      line-height: 1.5;
      font-size: 1.2rem;
    }
  }
  .vid-prod-img {
    padding: 8px;
  }
}
</style>